// USERS LIST
export const GET_USERS_LIST = "GET_USERS_LIST";
export const SET_USERS_LIST = "SET_USERS_LIST";
export const ADD_USER_TO_LIST = "ADD_USER_TO_LIST";
export const DELETE_USER_FROM_LIST = "DELETE_USER_FROM_LIST";

export const SHOW_USERS_LOADING = "SHOW_USERS_LOADING";
export const HIDE_USERS_LOADING = "HIDE_USERS_LOADING";

/* ERRORS */
export const SET_ERROR_USERS_LIST = "SET_ERROR_USERS_LIST";
